import { space } from '../spacing.js';
import { colors } from '../colors.js';
import { opacity } from '../opacity.js';
import { sizes } from '../sizing.js';
import { borderWidths, borderStyles } from '../borders.js';
export const radioButton = {
    defaultColor: colors.neutrals[700],
    activeColor: colors.indigos[500],
    disabledOpacity: opacity.faded,
    marginRight: space.x2,
    minHeight: sizes.x5,
    borderStyle: borderStyles.solid,
    activeBorderWidth: borderWidths.md,
    borderWidth: borderWidths.sm,
    hoverBoxShadow: {
        alpha: 'x5',
        style: 'medium',
        color: 'primary',
    },
};
export const radioGroup = {
    errorColor: colors.reds[500],
    descriptionColor: colors.neutrals[700],
    buttonGap: space.x3,
};
//# sourceMappingURL=radio-group.js.map